export enum ChipType {
  ROLE = 'ROLE',
  POSITION = 'POSITION',
  STATUS = 'STATUS'
}